<template>
  <section>
    <div class>
      <div class="utab clearfix">
        <div class="flex">
          <div>
            <el-select v-model="searchtype" placeholder="请选择搜索类型">
              <el-option label="原始单号" value="3"></el-option>
              <el-option label="商品名称" value="2"></el-option>
            </el-select>
          </div>
          <div class="flex">
            <input type="text"  style="margin:0 24px ;" placeholder="请输入关键字" class="layui-input" v-model="keyword" />
           
            <el-button  type="primary" class="exportantOrder" @click="search">查询</el-button>
          </div>
        </div>
      </div>
      <el-table
        :span-method="arraySpanMethod"
        :data="allOrder.data"
        ref="multipleTable"
        border
        style="width:98%; margin: 20px auto"
      >
        <el-table-column prop="orderno" label="退款订单号" width="100"></el-table-column>
        <el-table-column prop="orderno1" label="原始订单号" width="100"></el-table-column>
        <el-table-column prop="addtime" label="申请时间" width="100"></el-table-column>
        <el-table-column prop="num" label="数量" width="60"></el-table-column>
        <el-table-column prop="amount" label="申请退款金额" width="70"></el-table-column>
        <el-table-column prop="amount1" label="实际退款金额" width="70"></el-table-column>
        <el-table-column label="商品信息" width="260" class-name="tablegoodsinfo">
          <template slot-scope="scope">
            <div class="hebin">
              <div class="clearfix cpinfo flex">
                <div class="img">
                  <a :href="'product/'+ scope.row.productid+'.html'"  target="_blank">
                    <img :src="scope.row.indexpic" />
                  </a>
                </div>
                <div class="cont flex">
                  <div class style="width:160px">
                    <div class="name ellipsis-2">{{scope.row.title}}</div>
                    <div class="info">{{scope.row.specnames}}</div>
                    <div class="cart-price">{{scope.row.price}}*{{scope.row.num}}</div>
                  </div>
                  <div class="color-primary" style="width:50px;text-align:center">{{scope.row.unit}}</div>
                  <div class="color-primary" style="width:60px;text-align:right">{{scope.row.price}}</div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单位" width="60"></el-table-column>
        <el-table-column label="单价" width="70"></el-table-column>
        <el-table-column prop="remark" label="申请备注" width="120"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.type1==1">
              <el-button
                type="primary"
                size="small"
                class="mb10"
                @click="toDetail(scope.row)"
              >{{refundstatus[scope.row.status]}}</el-button>
            </div>
            <div v-else>
              <el-button
                type="primary"
                size="small"
                class="mb10"
                v-if="scope.row.status==2"
                @click="toDetail(scope.row)"
              >{{refundstatus['2']}}</el-button>
              <el-button
                type="primary"
                size="small"
                class="mb10"
                v-else-if="scope.row.status==3"
                @click="toDetail(scope.row)"
              >{{refundstatus['3']}}</el-button>
              <el-button
                type="primary"
                size="small"
                class="mb10"
                v-else
                @click="toDetail(scope.row)"
              >{{refundstatus1[scope.row.status1]}}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex ju-ar">
        <el-pagination
          class="fenye"
          @size-change="handleSizeChange"
          @current-change="currentorder"
          :current-page="allOrder.current_page"
          :page-sizes="[5, 10, 20, 50,100]"
          :page-size="allOrder.per_page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allOrder.total"
        ></el-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import eventBus from "../../static/eventBus.js";
export default {
  name: "Order",
  data() {
    return {
      userInfo: {},
      orderno: getParameterByName("orderno") || "",
      guid: sessionStorage.guid,
      indexData: {},
      nowStatus: "",
      keyword: "",
      refundstatus: {
        "1": "退款中",
        "2": "拒绝退款 查看原因",
        "3": "已退款 查看退款"
      },
      refundstatus1: {
        "0": "退货审核中",
        "1": "同意退货 请退货",
        "2": "待商家确认收货",
        "3": "商家已收货 退款中",
        "4": "商家拒绝收货 查看原因"
      },
      multipleSelection: [],
      //   orderstatus: [
      //     { 0: "待付款" },
      //     { 1: "待发货" },
      //     { 2: "待收货" },
      //     { 3: "已完成" },
      //     { 4: "已取消" },
      //     { 5: "已退款" }
      //   ],
      searchtype: "",
      page: 1,
      pagesize: 5,
      allOrder: { data: [] }, //全部订单的数据
      goodsKeyWord: ""
    };
  },
  props: {
    now_status: {
      type: String,
      default: ""
    },
    levelid: {
      type: [String, Number]
    }
  },
  watch: {
    orderno(newValue, oldValue) {
      eventBus.$emit("my-event", {
        orderno: newValue,
        order: true
      });
    }
  },
  methods: {
    toDetail(item) {
      console.log("ndwuefgrefyureyugttyrtgyrygy",item)
      this.$router.push(`/returnMoney?refundorder=${item.orderno}&type=2`);
    },
    currentorder(e) {
      this.page = e;
      this.getOrderList();
    },
    handleSizeChange(e) {
      this.pagesize = e;
      this.page = 1;
      this.getOrderList();
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 6) {
        return [1, 3];
      } else if (columnIndex === 7) {
        return [0, 0];
      } else if (columnIndex === 8) {
        return [0, 0];
      }
    },
    // 封装获取数据的方法
    async getOrderList() {
      let res = await this.$fetch("member/refundorderlist", {
        body: {
          page: this.page,
          pagesize: this.pagesize,
          searchtype: this.searchtype,
          keyword: this.keyword
        }
      });

      res.per_page = parseInt(res.per_page);
      this.allOrder = res;
    },

    currentPageorder(e) {
      this.page = e;
      this.getOrderList();
    },
    orderdetail(orderno) {
      this.orderno = orderno;
    },

    // 搜索
    search() {
      this.getOrderList();
    },
    // 改变tab
    changeTab(type) {
      console.log(type);
      this.nowStatus = type;
      console.log(this.now_status);
      this.getOrderList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    keyupSubmit() {
      document.onkeydown = e => {
        let _key = window.event.keyCode;
        if (_key == 13) {
          this.search();
        }
      };
    }
  },
  created() {
    this.keyupSubmit();
  },
  async mounted() {
    // this.nowStatus = this.now_status;
     if (this.orderno) {
      this.searchtype='3';
      this.keyword = this.orderno;
    }
    await this.getOrderList();
      // alert(this.orderno)
   
    // this.fenye();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang='scss' scoped>
.img {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
  a {
    display: inline-block;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.cont {
  // width: 150px;
  margin: 0 10px;
}
.cart-price {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/refundOrder.vue